import worldMap from '@/assets/logalto-world-map.png';
import { AppHeader } from '@/components/organisms/AppHeader';
import type { Locale } from '@/lib/platformTypes';
import type { ReactNode } from 'react';

type Props = { children: ReactNode; locale: Locale };

export function EntryTemplate({ children, locale }: Props) {
	return (
		<div className="min-h-screen bg-white">
			<AppHeader locale={locale} />
			<main className="relative grid min-h-[calc(100vh-3.75rem)] place-items-center overflow-hidden px-3 py-12 max-sm:px-0 max-sm:py-0 sm:px-5">
				<div
					className="pointer-events-none absolute top-0 right-[5%] left-[5%] h-full max-h-[775px] bg-contain bg-center bg-no-repeat opacity-10 max-sm:hidden"
					style={{ backgroundImage: `url(${worldMap})` }}
					aria-hidden="true"
				/>
				{children}
			</main>
		</div>
	);
}
